/** Polyfill */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

/** window.fetch POLYFILL */
import 'whatwg-fetch';

import './service-worker';

/** Libs */
import Vue from 'vue';
import VueCookie from 'vue-cookies';
import VueTheMask from 'vue-the-mask';
import VueMoneyMask from 'v-money';
import VueCharts from 'vue-charts';
import json2csv from 'json2csv';
import moment from 'moment';
import lodash from 'lodash';
import score from 'string-score';

import iSwal from 'sweetalert2/dist/sweetalert2.min';

import fontawesome from './plugin/fontawesome';

// CSS Imports are now inside app.scss

import 'jquery-ui-bundle/jquery-ui.min';

import 'bootstrap/dist/js/bootstrap.min';

import 'static/jquery.datatables.min';

import 'datatables.net-buttons/js/dataTables.buttons.min';

import 'datatables.net-buttons/js/buttons.html5.min';
import 'datatables.net-buttons/js/buttons.print.min';

/** Imports */
import PromiseCall from './objects/PromiseCall';
import globalFunction from './plugin/globalFunction';
import VueEvents from './plugin/events';

import App from './App.vue';
import router from './router';
import ImportComponent from './plugin/importComponent';
import CustomDirectives from './plugin/directives';

/** Objects */
import User from './objects/User';
import Chat from './objects/Chat';
import Utils from './objects/Utils';
import Portal from './objects/Portal';
import Company from './objects/Company';
import Brain from './objects/Brain';
import Dev from './objects/Dev';
import CurrentModule from './objects/CurrentModule';
import Script from './objects/Script';
import Format from './objects/Format';
import DirectScript from './objects/DirectScript';
import Swal from './objects/Swal';
import EmailValidator from './objects/EmailValidator';
import Websockets from './objects/Websockets';
import Notifications from './objects/Notifications';

/* Classe de cálculos dos valores dos produtos da Nota Fiscal */
import MirrorNfCalcs from './components/MirrorNF/MirrorNfCalcs';

/**
 * Initializations
 */
globalFunction(global);

Vue.use(VueCookie);

VueCookie.config('10h');

Vue.use(ImportComponent);
Vue.use(CustomDirectives);

Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV !== 'production';

/**
 * OBJ
 */
Vue.prototype.$company = new Company(Vue);
Vue.prototype.$chat = new Chat(Vue);
Vue.prototype.$portal = new Portal(Vue);
Vue.prototype.$user = new User(Vue);
Vue.prototype.$utils = new Utils(Vue);
Vue.prototype.$currentModule = new CurrentModule(Vue);
Vue.prototype.$script = new Script(Vue);
Vue.prototype.$directScript = new DirectScript(Vue);
Vue.prototype.$format = new Format(Vue);
Vue.prototype.$swal = new Swal(Vue);
Vue.prototype.$websockets = new Websockets(Vue);
Vue.prototype.$notifications = new Notifications(Vue);
Vue.prototype.$brain = new Brain(Vue);
Vue.prototype.$dev = new Dev(Vue);
Vue.prototype.$emailValidator = new EmailValidator(Vue);
Vue.prototype.$mirrorNfCalcs = new MirrorNfCalcs(Vue);

Vue.use(VueEvents);
Vue.use(VueTheMask);
Vue.use(VueMoneyMask);
Vue.use(VueCharts);

global.json2csv = json2csv;
global.moment = moment;
global._ = lodash;
global.swal = iSwal;
global.score = score;
global.PromiseCall = PromiseCall;
global.ProVue = Vue;
global.brain = Vue.prototype.$brain;

brain.router = router;

// ? WORKAROUND FOR JQUERY 3.5.X BREAKING CHANGE FOR XHTML SELF-CLOSING TAGS
// eslint-disable-next-line no-useless-escape
const rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
// eslint-disable-next-line func-names
$.htmlPrefilter = function (html) {
  return html.replace(rxhtmlTag, '<$1></$2>');
};

/**
 * INIT
 */
Vue.prototype.$dev
  .check()
  .then(() => Vue.prototype.$company.reloadJson())
  .then(() => Vue.prototype.$portal.loadColors(
    Vue.prototype.$company.json.style.color.primary,
    Vue.prototype.$company.json.style.color.secondary,
    Vue.prototype.$company.json.style.color.active,
  ))
  .then(() => {
    document.title = Vue.prototype.$company.json.appTitle;

    Vue.prototype.$portal.isLoaded = true;
    init(false);
  })
  .catch(err => {
    console.log('ERRO - APP ->', err);
    init(true);
  });

function init(error) {
  new Vue({
    el: '#app',
    router,
    components: { App },
    beforeCreate() {
      window.$ = $;

      this.$brain.route = this.$route;
      this.$brain.router = this.$router;
      this.$company.router = this.$router;
      window.fontawesome = fontawesome;

      // window.brain = this.$brain;

      const isIE = /^(IE|MSIE)/.test(brain.getBrowserInfo());
      if (isIE) $.ajaxSetup({ cache: false });

      moment.locale('pt-BR');

      if (error) this.$brain.sendTo404Page(this.$route.fullPath);
    },
    template: '<App/>',
  });
}
